// extracted by mini-css-extract-plugin
export default {"danger":"MilestoneDescription-module__danger--uV2jW","subtle":"MilestoneDescription-module__subtle--wCZ7c"};